import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import api from '../api/axiosConfig';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuthStatus = async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      await fetchUserInfo();
    } catch (error) {
      try {
        await refreshToken();
        await fetchUserInfo();
      } catch (refreshError) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchUserInfo = async () => {
    const response = await api.get('user/me/');
    setUser(response.data);
    return response.data;
  };

  const refreshToken = async () => {
    const refresh = localStorage.getItem('refresh_token');
    if (!refresh) throw new Error('No refresh token');
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL || ''}/api/token/refresh/`,
      { refresh }
    );
    localStorage.setItem('access_token', response.data.access);
    return response.data.access;
  };

  const login = async (username, password) => {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL || ''}/api/token/`,
      { username, password }
    );
    localStorage.setItem('access_token', response.data.access);
    localStorage.setItem('refresh_token', response.data.refresh);
    await fetchUserInfo();
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
